const translation = {
  nav_home: "Inicio",
  nav_about: "Nosotros",
  nav_products: "Productos",
  nav_gallery: "Galería",
  nav_contact: "Contacto",
  nav_cta: "Contáctanos",

  // ... existing keys ...
  hero_badge: "Envasado",
  hero_title: "Aceites de Cocina",
  hero_title2: "Vegetales",
  hero_subtitle: "Somos líderes en el envasado y distribución de aceites de alta calidad. Comprometidos con la excelencia, llevamos el mejor aceite a su mesa con los más altos estándares de calidad.",
  hero_btn1: "Nuestros Productos",
  hero_btn2: "Contáctanos",

  about_badge: "Quiénes Somos",
  about_title: "Tradición y Calidad en Cada Gota",
  about_process_label: "Procesos de envasado",
  about_partner: "Tu socio estratégico en aceite alimentario",
  about_strategy: "Combinando tecnología, trazabilidad y servicio corporativo",
  about_feature_quality_title: "Calidad garantizada",
  about_feature_quality_desc: "Control exhaustivo de cada lote para cumplir normas alimentarias.",
  about_feature_distribution_title: "Distribución nacional",
  about_feature_distribution_desc: "Cobertura en todo el país con logística segura y entregas puntuales.",
  about_feature_customer_title: "Compromiso con el cliente",
  about_feature_customer_desc: "Atención personalizada y soluciones fiables para cada cadena de suministro.",
  about_feature_certified_title: "Productos certificados",
  about_feature_certified_desc: "Aceites con certificaciones de calidad y trazabilidad comprobada.",
  about_p1: "Somos una empresa especializada en el envasado y distribución de aceites comestibles de alta calidad. Con años de experiencia en el sector, nos hemos consolidado como un referente confiable para distribuidores, supermercados y empresas del sector alimentario.",
  about_p2: "Trabajamos con los mejores proveedores de aceite de palma, soya, girasol y maíz, garantizando que cada producto que envasamos cumpla con los más rigurosos controles de calidad e inocuidad alimentaria.",
  about_p3: "Nuestra planta de envasado cuenta con tecnología de punta, líneas de producción automatizadas y un equipo humano comprometido con la excelencia en cada proceso, desde la recepción del aceite a granel hasta el producto final listo para distribución.",
  about_stat1: "25+",
  about_stat1_label: "Años de experiencia",
  about_stat2: "15",
  about_stat2_label: "Marcas envasadas",
  about_stat3: "8",
  about_stat3_label: "Tipos de aceites",

  features_badge: "Nuestro Compromiso",
  features_title: "Compromiso con la Excelencia",
  feat1_title: "Planta Avanzada",
  feat1_desc: "Contamos con instalaciones de última tecnología para el envasado de aceites con altos estándares de higiene y precisión.",
  feat2_title: "Certificación de Calidad",
  feat2_desc: "Todos nuestros procesos cuentan con certificaciones internacionales de calidad e inocuidad alimentaria.",
  feat3_title: "Cadena de Frío",
  feat3_desc: "Mantenemos la cadena de frío en todo el proceso para garantizar la frescura y propiedades del aceite.",
  feat4_title: "Distribución Nacional",
  feat4_desc: "Red de distribución que cubre todo el territorio nacional, garantizando entregas puntuales.",
  feat5_title: "Envases a Medida",
  feat5_desc: "Ofrecemos soluciones de envasado personalizadas en diferentes presentaciones y tamaños.",
  feat6_title: "Sostenibilidad",
  feat6_desc: "Comprometidos con el medio ambiente, utilizamos materiales reciclables y procesos eficientes.",

  products_badge: "Catálogo",
  products_title: "Línea de Aceites",
  products_subtitle: "Selecciona una marca para explorar su línea completa de aceites envasados con los más altos estándares de calidad.",
  products_presentations: "Presentaciones disponibles",
  products_cta: "Solicitar Cotización",
  products_hint: "Haz clic en una presentación para ver el envase correspondiente",

  brand_delsarten: "Delsarten",
  brand_delsarten_tagline: "Calidad y tradición en cada envase — Línea Delsarten",
  brand_miaceite: "Alimorca",
  brand_miaceite_tagline: "Sabor auténtico para cada cocina — Línea Alimorca",
  brand_alimorca_palma: "Aceite de Palma Alimorca",
  brand_alimorca_palma_tagline: "Calidad y pureza en cada gota — Aceite de Palma Alimorca",

  ds_vegetal_name: "Aceite Vegetal Delsarten",
  ds_vegetal_type: "Aceite Vegetal",
  ds_soya_name: "Aceite de Soya Delsarten",
  ds_soya_type: "Aceite de Soya",

  ma_vegetal_name: "Aceite Vegetal Alimorca",
  ma_vegetal_type: "Aceite Vegetal",
  ma_soya_name: "Aceite de Soya Alimorca",
  ma_soya_type: "Aceite de Soya",
  ma_palma_name: "Aceite de Palma Alimorca",
  ma_palma_type: "Aceite de Palma",

  prod1_name: "Aceite Vegetal \"Delsarten\"",
  prod1_type: "Aceite Vegetal",
  prod1_desc: "",

  prod2_name: "Aceite de Soya \"Alimorca\"",
  prod2_type: "Aceite de Soya",
  prod2_desc: "",

  
  //prod3_type: "Aceite de Girasol",
  //prod3_desc: "Aceite de girasol de primera calidad, con sabor neutro y alto punto de humo. Ideal para todo tipo de preparaciones culinarias.",

  prod4_name: "Alimorca",
  prod4_type: "Aceite Vegetal",
  prod4_desc: "",

  prod5_name: "Aceite de Canola",
  prod5_type: "Aceite de Canola",
  prod5_desc: "Aceite de canola refinado, bajo en grasas saturadas y rico en omega-3. Ideal para frituras, horneados y aderezos por su sabor neutro y ligero.",

  prod6_name: "Aceite Vegetal Mezcla",
  prod6_type: "Aceite Vegetal",
  prod6_desc: "Mezcla equilibrada de aceites vegetales para uso doméstico e industrial. Versátil, económico y de excelente rendimiento.",

  gallery_badge: "Nuestra Galería",
  gallery_title: "Nuestras Instalaciones y Productos",
  gallery_subtitle: "Conoce nuestra planta de envasado y la variedad de aceites que producimos con los más altos estándares de calidad.",
  gallery_card1_title: "Línea de Producción",
  gallery_card1_desc: "Proceso automático de llenado y control de calidad para garantizar la pureza de nuestro aceite.",
  gallery_card2_title: "Envasado",
  gallery_card2_desc: "Sellado y etiquetado con tecnología avanzada para mantener la frescura y calidad del producto.",
  gallery_card3_title: "Empaque",
  gallery_card3_desc: "Empaque seguro y resistente para proteger el producto durante su transporte y distribución.",
  gallery_card4_title: "Almacenamiento",
  gallery_card4_desc: "Almacenamiento en condiciones óptimas para asegurar la disponibilidad y calidad de nuestros productos.",

  contact_badge: "Contacto",
  contact_title: "Contáctanos",
  contact_subtitle: "¿Necesitas información sobre nuestros servicios de envasado y distribución? Estamos aquí para ayudarte.",
  contact_address_title: "Dirección",
  contact_address: "3801 Avalon Park E Blvd FL 2 STE 217, Orlando, Florida, United States",
  contact_phone_title: "Teléfono",
  contact_email_title: "Email",
  contact_hours_title: "Horario",
  contact_hours: "Lunes a Viernes: 9:00am - 5:00pm",
  form_name: "Nombre completo",
  form_company: "Empresa",
  form_email: "Correo electrónico",
  form_phone: "Teléfono",
  form_subject: "Asunto",
  form_message: "Mensaje",
  form_submit: "Enviar Mensaje",
  form_sending: "Enviando...",
  form_consent: "Al enviar este formulario, autorizas el tratamiento de los datos proporcionados para atender tu solicitud de contacto.",
  form_success: "¡Mensaje enviado! Nos pondremos en contacto pronto.",

  footer_desc: "Líderes en envasado y distribución de aceites comestibles de alta calidad. Comprometidos con la excelencia y la satisfacción de nuestros clientes.",
  footer_links: "Enlaces Rápidos",
  footer_services: "Productos",
  footer_serv1: "Aceite de Palma",
  footer_serv2: "Aceite de Soya",
  footer_contact: "Contacto",
  footer_rights: "Todos los derechos reservados.",
  footer_policy: "Política de Privacidad",
  footer_terms: "Términos de Uso",

  lang_toggle: "EN",
};

export default translation;
